<loader *ngIf="showLoader"></loader>
<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="card">
      <div class="card-body spend-earn-section">

        <div class="row m-0 p-0">
          <div class="col-md-8 mb-10 p-0">
            <div class="row">
              <div class="col-12">
                <h4 class="content-header-title" style="color: black">Vouchers</h4>
                <p class="credit-text">Claim exciting vouchers with a minimum of <span class="credit-limit-apply">500
                    credits</span> here!</p>
              </div>
            </div>

            <div class="row mt-6 mb-20 ml-0">
              <div class="col-12 feature-section-box">
                <div class="d-flex align-items-center feature-section" *ngFor="let singleReward of rewardBrand"
                  [ngClass]="{ 'image-enlarged': selectedItemId === singleReward.id }">
                  <img [src]="singleReward.logourl" (click)="selectItem(singleReward)" alt="Icon" class="image-small" />
                </div>
              </div>
            </div>

            <div class="spend-text mb-20 mb-md-0 ml-0 p-0 col-12">
              Note: Vouchers are non-returnable and non-replaceable and valid for 6 months from the issue date.
            </div>
          </div>

          <div class="col-md-4 spend-card mt-0" *ngIf="selectedItem">
            <div class="spend-card-body">
              <div class="row">
                <div class="col-12 d-flex justify-content-start align-items-center">
                  <div class="brand-logo-section">
                    <img [src]="selectedItem.logourl" />
                  </div>
                  <div class="">
                    <p class="brand-name">{{ selectedItem.brandname }}</p>
                    <p class="fw-500 fs-14"> Available Credits <span style="color:#53C9EA; font-weight: 700;">{{
                        availableCredits }}</span></p>
                  </div>
                </div>
                <div class="col-12 claim-amount">
                  <ng-select placeholder="Select Claim Amount" class="fs-12" [clearable]="false" [searchable]="false"
                    required [items]="claimAmounts" [(ngModel)]="selectedClaimAmount" bindLabel="amount"
                    bindValue="amount"> </ng-select>
                </div>
                <div class="col-12 claim-btn-section">
                  <button type="button" rippleEffect class="btn btn-spend fs-10"
                    (click)="getClaimReward()">Proceed</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-12">
            <div class="dashed-border"></div>
          </div>
        </div>

        <div class="row p-0 m-0">
          <div class="col-12 col-md-8 p-0">
            <div class="row p-0 m-0">
              <div class="col-md-12 p-0 m-0">
                <h4 class="content-header-title float-left mb-10" style="color: black">Spend & Earn</h4>
              </div>
              <div class="col-md-12 p-0 m-0 credit-text">
                Transform your everyday expenses into valuable rewards.
              </div>
              <div class="row mt-20 p-0 fw-600">
                <div class="col-md-12 d-flex align-items-center all-options">
                  <div class="mr-4 d-flex align-items-center">
                    <input type="radio" name="radios" id="earnedRadio" [(ngModel)]="selectedOption" value="earned" />
                    <label for="earnedRadio" class="ml-1 m-0">Earned</label>
                  </div>

                  <div class="mr-4 d-flex align-items-center">
                    <input type="radio" name="radios" id="spentRadio" [(ngModel)]="selectedOption" value="spent" />
                    <label for="spentRadio" class="ml-1 m-0">Spent</label>
                  </div>

                  <div class="d-flex align-items-center">
                    <input type="radio" name="radios" id="claimedRadio" [(ngModel)]="selectedOption" value="claimed" />
                    <label for="claimedRadio" class="ml-1 m-0">Claimed Vouchers</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row p-0 m-0">
              <div class="earned-credits-container earned-container" *ngIf="selectedOption === 'earned'">
                <section class="credits-card">
                  <div class="credits-content col-12">
                    <!-- <div class="credits-header">
                                  
                                </div> -->
                    <div *ngFor="let credit of creditClaimHistory.earnedCredits" class="credits-row ">
                      <div class="row p-0 m-0">
                        <p class="credits-header col-12">Credits issued to you.</p>
                        <div class="col-12 credit-records">
                          <div class="credit-record">
                            <div class="date credits-date">{{ credit.createdAt | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="create-status">
                            <span class="credits-points">{{ credit.credit }} Points</span>
                            <span class="credits-status">{{ credit.creditStatus }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p *ngIf="creditClaimHistory.earnedCredits.length === 0">No earned credits found.</p>
                  </div>
                </section>
              </div>

              <div class="earned-credits-container spend-container" *ngIf="selectedOption === 'spent'">
                <section class="credits-card">
                  <div class="credits-content col-12">
                    <div *ngFor="let spend of creditClaimHistory.spentCredits" class="credits-row ">
                      <div class="row p-0 m-0">
                        <p class="credits-header col-12">{{spend.description}}</p>
                        <div class="col-12 credit-records">
                          <div class="credit-record">
                            <div class="date credits-date">{{ spend.claimDate | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="create-status">
                            <span class="credits-points">{{ spend.pointsRequired }} Points</span>
                            <span class="credits-status" [ngClass]="{'spend-approved': spend.status === 'IN_PROCESS', 'spend-pending' : spend.status === 'APPROVED' }">{{ spend.status }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p *ngIf="creditClaimHistory.earnedCredits.length === 0">No earned credits found.</p>
                  </div>
                </section>
              </div>

              <div class="earned-credits-container claimed-voucher-container" *ngIf="selectedOption === 'claimed'">
                <section class="credits-card">
                  <div class="credits-content">

                    <div *ngFor="let voucher of lockedVoucherList" class="credits-row ">
                      <div class="row p-0 m-0">
                        <p class="credits-header col-12">{{ voucher.title }}</p>
                        <div class="col-12 credit-records unlock-voucher">
                          <div class="credit-record">
                            <div class="date credits-date">Validity: {{ voucher.startDate | date:'dd/MM/yyyy' }} to {{ voucher.endDate | date:'dd/MM/yyyy' }}</div>
                          </div>
                          <div class="create-status">
                            <span class="credits-voucher" *ngIf="voucher.unLock == false" (click)="unlockVoucher(voucher.id)">Unlock Voucher</span>
                            <span class="credits-code" *ngIf="voucher.unLock == true"> {{ voucher.rewardCode }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngFor="let voucher of unlockedVoucherList" class="credits-row ">
                      <div class="row p-0 m-0">
                        <p class="credits-header col-12">{{ voucher.title }}</p>
                        <div class="col-12 credit-records unlock-voucher">
                          <div class="credit-record">
                            <div class="date credits-date">Validity: {{ voucher.startDate | date:'dd/MM/yyyy' }} to {{ voucher.endDate | date:'dd/MM/yyyy' }}</div>
                          </div>
                          <div class="create-status">
                            <span class="credits-voucher" *ngIf="voucher.unLock == false" (click)="unlockVoucher(voucher.id)">Unlock Voucher</span>
                            <span class="credits-code" *ngIf="voucher.unLock == true"> {{ voucher.rewardCode }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p *ngIf="unlockedVoucherList.length === 0 && lockedVoucherList.length === 0">No Claim Vouchers found.</p>
                    <!-- <div *ngFor="let voucher of unlockedVoucherList" class="credits-row">
                      <span class="credits-date">Validity: {{ voucher.startDate | date:'dd/MM/yyyy' }} to {{
                        voucher.endDate | date:'dd/MM/yyyy' }}</span> -->
                      <!-- <span class="credits-date"></span>
                                  <span class="credits-points">Claimed Points: {{ claim.points }}</span>
                                  <span class="credits-status" [style.color]="claim.status === 'APPROVED' ? 'green' : 'red'">{{ claim.status }}</span> -->
                      <!-- <span class="credits-voucher" *ngIf="voucher.unLock == false"
                        (click)="unlockVoucher(voucher.id)">Unlock Voucher</span>
                      <span class="credits-code" *ngIf="voucher.unLock == true">CODE {{ voucher.rewardCode }}</span>
                    </div> -->
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 p-0">
            <div class="custom-col-md-6">
              <section class="custom-section">
                <table class="custom-table custom-text-center">
                  <thead>
                    <tr>
                      <th>Transaction Value</th>
                      <th>Earn Credits</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Upto $2000</td>
                      <td>100</td>
                    </tr>
                    <tr>
                      <td>$2001-$3000</td>
                      <td>150</td>
                    </tr>
                    <tr>
                      <td>$3001-$5000</td>
                      <td>200</td>
                    </tr>
                    <tr>
                      <td>$5001-$7500</td>
                      <td>250</td>
                    </tr>
                    <tr>
                      <td>$7501-$10000</td>
                      <td>400</td>
                    </tr>
                    <tr>
                      <td>$10001-$15000</td>
                      <td>500</td>
                    </tr>
                    <tr>
                      <td>$15001-$20000</td>
                      <td>750</td>
                    </tr>
                    <tr>
                      <td>Greater than $20000</td>
                      <td>1000</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>



        <div class="row">

          <div class="col-12">
          </div>












          <!--<div class="earned-credits-container " *ngIf="selectedOption === 'earned'">
    <section class="credits-card">
        <div class="credits-content col-12">
            <div class="credits-header">
                <p>Credits issued to you.</p>
            </div>
            <div class="credits-row">
                <span class="credits-date">24/07/2024</span>
                <span class="credits-points">500 Points</span>
                <span class="credits-status">EARNED</span>
            </div>
            <div class="credits-divider"></div>
            <div class="credits-header">
                <p>Credits issued to you.</p>
            </div>
            <div class="credits-row">
                <span class="credits-date">11/07/2024</span>
                <span class="credits-points">5000 Points</span>
                <span class="credits-status">EARNED</span>
            </div>
        </div>
    </section>
</div>

<div class="earned-credits-container" *ngIf="selectedOption === 'spent'">
    <section class="credits-card">
        <div class="credits-content">
            <div class="credits-header col-md-7">
                <p>Consumed for - Amazon | Claim against voucher Amazon</p>
            </div>
            <div class="credits-row">
                <span class="credits-date">11/07/2024</span>
                <span class="credits-points">500 Points</span>
                <span class="credits-status">USED</span>
            </div>
            
        </div>
    </section>
</div>

<div class="earned-credits-container" *ngIf="selectedOption === 'claimed'">
    <section class="credits-card1">
        <div class="credits-content">
            <div class="credits-header">
                <p>Amazon</p>
            </div>
            <div class="credits-row">
                <span class="credits-date">18/07/2024 11:18 AM</span>
                <span class="credits-points">Claimed Points:500</span>
                <span class="credits-status">APPROVED</span>
                <span class="credits-voucher" *ngIf="!isVoucherUnlocked" (click)="unlockVoucher()">Unlock Voucher</span>
                <span class="credits-code" *ngIf="isVoucherUnlocked">CODE 0000</span>
            </div>
            <div class="credits-divider"></div>
            <div class="credits-header">
                <p>Amazon</p>
            </div>
            <div class="credits-row1">
                <span class="credits-date">18/07/2024 11:18 AM</span>
                <span class="credits-points"style="">Claimed Points:500</span>
                <span class="credits-status" style="color: red;">PENDING</span>
                
                
            </div>
        </div>
    </section>
</div>-->




        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #SpendModal let-modal>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="spend-img">
      <img src="assets/images/spend-n-earn/Popup.png" class="spend-img" />
    </div>
    <div class="spend-text1">YAY!</div>
    <div class="spend-text2">Your voucher will be emailed to you on your registered email id within 48 hrs</div>

    <div class="col-md-12 mt-20">
      <button type="button" rippleEffect class="btn-spend-modal fs-10 w-80" (click)="closeModalAndNavigate(modal)">
        Ok
      </button>
    </div>
  </div>
</ng-template>